export const AgentActions = {
  Join: "join",
  Leave: "leave",
};

export const ConversationEvents = {
  Messages: "messages",
  Typing: "typing",
  Agent: "agent",
  Error: "error",
  Ready: "ready",
};
